import React from 'react';
import Link from 'next/link';
import useStyles from './styles';

export type LogoMarkProps = {
  href?: string;
  width?: number;
  height?: number;
  className?: string;
};

/** Inline SVG matches apps/site/public/img/elevator-icon-white.svg */
const LogoMarkSvg = ({
  className,
  width,
  height,
}: {
  className?: string;
  width: number;
  height: number;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 151 151"
    width={width}
    height={height}
    className={className}
    preserveAspectRatio="xMidYMid meet"
    aria-hidden
  >
    <path
      fill="#FFFFFF"
      fillRule="evenodd"
      d="M79.5297572,24 L88.6068756,37.0058727 L116.794399,37.0595795 L144,99.0168152 L124.872494,128 L70.524422,128 L63.3839387,114.993496 L34.1942726,114.993496 L7,53.0039703 L26.1558706,24 L79.5297572,24 Z M98.9323019,46.9994295 L71.1409942,109.986851 L126.72361,109.986851 L98.9323019,46.9994295 Z M82.1585,45.9996292 L25.6936208,45.9996292 L53.9260604,109.986851 L82.1585,45.9996292 Z"
    />
  </svg>
);

/**
 * Elevator icon mark (no wordmark). White fill — use on dark backgrounds.
 */
const LogoMark: React.FC<LogoMarkProps> = ({
  href,
  width = 32,
  height = 32,
  className,
}) => {
  const { classes, cx } = useStyles();

  const content = (
    <div className={cx(classes.logoWrapper, className)}>
      <LogoMarkSvg className={classes.baseSvg} width={width} height={height} />
    </div>
  );

  return href ? <Link href={href}>{content}</Link> : content;
};

export default LogoMark;
